import { AccommodationsSearchRequestDto } from '@/features/AccommodationList/api/requestTypes';
import { formatDate } from '@/utils/dates/formatDate';
import { optionsLongMonth } from '@/utils/dates/formatOptions';
import getHtmlFromMarkdown from '@/utils/markdown/getHtmlFromMarkdown';
import dayjs from 'dayjs';
import { TFunction } from 'i18next';

export const getWelcomeMessageHtml = (
  t: TFunction,
  searchRequest: AccommodationsSearchRequestDto | undefined
) => {
  const message = searchRequest
    ? t('welcomeWithSearchMessage', {
        locationName: searchRequest.location?.city,
        checkIn: formatDate(
          dayjs(searchRequest.checkIn).toDate(),
          optionsLongMonth
        ),
        checkOut: formatDate(
          dayjs(searchRequest.checkOut).toDate(),
          optionsLongMonth
        ),
        guests: t('guests', {
          count: searchRequest.adults + (searchRequest.children || 0) || 1
        })
      })
    : t('welcomeGeneralMessage');

  return getHtmlFromMarkdown(message);
};
